import { useEffect, useState } from 'react'
import { api } from '@/util/api'

export const DEFAULT_INGEST_REGION = 'europe'

export type IngestRegion = { id: string; name: string }

type IngestRegionResource = { id: string; attributes: { name: string } }

/** The regions an event can stream through. Empty until loaded, and when the list can't be fetched. */
export function useIngestRegions(): IngestRegion[] {
  const [regions, setRegions] = useState<IngestRegion[]>([])

  useEffect(() => {
    let active = true
    api
      .get<{ data: IngestRegionResource[] }>('/ingest_regions')
      .then((res) => {
        if (active && Array.isArray(res.data)) {
          setRegions(res.data.map(({ id, attributes }) => ({ id, name: attributes.name })))
        }
      })
      .catch(() => {
        // Without the list the picker stays hidden and events keep the server default.
      })
    return () => {
      active = false
    }
  }, [])

  return regions
}
